import { Injectable, Injector } from '@angular/core';
//import {SqlLiteDatabase} from './SqlLiteDatabase';

import { Item } from "../../bayadic-shared-models/classes/item/Item";
import { Chat } from "../../bayadic-shared-models/chat/Chat";
import { AbstractChatMessage } from "../../bayadic-shared-models/classes/message/abstract-chat-message";
import { UserManagerProvider } from "../user-manager/user-manager";
import * as Tools from "../../bayadic-shared-models/tools/Tools";
import { MessageItemData } from '../../bayadic-shared-models/interfaces/message/MessageItemData';
import { LoggerService } from '../../app/services/logger.service';
@Injectable({
    providedIn: 'root'
  })
export class DatabaseManagerProvider {
    databaseVersion: number = 1;


    public database: IDBDatabase;
    public databaseObj: any;
    userManager: UserManagerProvider;

    constructor(public injector: Injector,
        public logger: LoggerService
    ) {
            this.userManager = this.injector.get(UserManagerProvider);
            this.init()
    }

    importSQL(sql: string): Promise<string> {
        return new Promise(async (resolve, reject) => {
            // if (!this.platform.is("cordova")) {
            //     resolve("no cordvoa");
            // }
            // else {

            //     // const user = await this.userManager.getUser()
            //     // if (!user) return false;
            //     // this.init(user)
            //     // .then(() => {
            //     //     this._PORTER.importSqlToDb(this.databaseObj, sql)
            //     //         .then((data) => {
            //     //             resolve(data);
            //     //         })
            //     //         .catch((e) => {
            //     //             reject(e);
            //     //         });
            //     // });
            //     // });
            // }
        });
    }
    // import (sqlFileAddress : string) {
    //     let sql = this.http
    //     return this.importSQL(sql);
    // }
    createTables() {
        this.databaseObj.executeSql('create table  IF NOT EXISTS items \n\
                                  (itemID  VARCHAR(32) UNIQUE,userID  VARCHAR(32),title  VARCHAR(32),name VARCHAR(32),type  VARCHAR(32),localCount  INT(10),description  text NOT NULL )', [])
            .then(() => {
                this.databaseObj.executeSql("ALTER TABLE items ADD COLUMN userID VARCHAR(32)")
                    .then(() => {

                        this.logger.debug("altered table items");

                    }).catch(e => {

                        this.logger.debug("error on create db", e);

                    })
                this.logger.debug("db items created");
            }).catch(e => {


            });
        this.databaseObj.executeSql('create table  IF NOT EXISTS messages \n\
                      (itemID  VARCHAR(32),messageID  VARCHAR(32) UNIQUE,\n\
                       status  VARCHAR(16),data text NOT NULL,\n\
                       content text,received INTEGER,folded INTEGER, \n\
                       repetittion INTEGER, receivedTime text, \n\
                       lastReviewedTime text, easinessFactor REAL, reviewTime text)', [])
            .then(() => {
                this.logger.debug('Tables are created');
            })
            .catch(e => {

                this.logger.debug("oooooooooooh no there waaaas an error");
                this.logger.debug(e)

            });
        this.createWordsTable();
    }
    private createWordsTable() {
        //        this.databaseObj.executeSql("drop Table words", []).then(()=>{
        //         this.logger.debug("database dropped");
        //        });
        //        this.databaseObj.executeSql("delete from words", [])
        //            .then(() => {this.logger.debug("all deleted")})
        this.databaseObj.executeSql('create table IF NOT EXISTS wordsSuggestion \n\
              (_id  integer primary key autoincrement, word text not null unique) \n\
               ', [])
            .then(() => {
                this.logger.debug('Executed SQLL');
            })
            .catch(e => {
                this.logger.debug(e)

            });
    }

    async init() {
        const user = this.userManager.user;
    }
    
    getFutureMessages() {
        return new Promise<Array<AbstractChatMessage>>((resolve, reject) => {
            let messages: Array<AbstractChatMessage> = [];
            let sqlLiteQuery = "select messageID, data,content, received, receivedTime, reviewTime,lastReviewedTime,easinessFactor ,repetittion"
                + " from messages";
            sqlLiteQuery += " WHERE reviewTime >= Datetime('" + Tools.Time.getToday() + "')";
            sqlLiteQuery += " GROUP BY reviewTime";
            this.logger.debug("sqlLiteQuery", sqlLiteQuery);
            this.databaseObj.executeSql(sqlLiteQuery, [])
                .then(data => {
                    if (data.rows.length > 0) {
                        for (var i = data.rows.length - 1; i >= 0; i--) {
                            // this.consoleDialog.log2("futrue message", data.rows.item(i));
                            // let message = new AbstractChatMessage();
                            // if (!message.content)
                            //     message.content = JSON.parse(data.rows.item(i).content);
                            // message.setReceivedFromInt(data.rows.item(i).received);
                            // message.setEasinessFactor(data.rows.item(i).easinessFactor);
                            // message.setRepetitions(data.rows.item(i).repetittion);
                            // message.setLastReviewedTime(data.rows.item(i).lastReviewedTime);
                            // message.setMessageID(data.rows.item(i).messageID);
                            // messages.push(message);
                        }
                    }
                    resolve(messages);
                }).catch(e => {
                    this.logger.debug("error from get leitner messages", e);
                });
        });
    }
    getItemsTableName() {
        return "items";
    }
    getMessagesTableName() {
        return "messages";
    }
    copyMessages(fromItem: Item, toItem: Item) {
        let prefix: string = toItem.itemID.substr(toItem.itemID.length - 4, toItem.itemID.length);
        let sqlString = "INSERT INTO " + this.getMessagesTableName() + " " +
            "SELECT  '" + toItem.itemID + "' as itemID, '" + prefix + "' || messageID as messageID,\n\
    status,replace(replace(data, '\"type\":\"dictionary\"','\"type\":\"leitner\"'),messageID, '"+ prefix + "' || messageID) as data ,\n\
    content,received,folded, \n\
    repetittion, receivedTime, \n\
    lastReviewedTime, easinessFactor, reviewTime FROM "+ this.getMessagesTableName()
            + " where itemID ='" + fromItem.itemID + "'";
        this.databaseObj.executeSql(sqlString, []).then(
            (result) => {
                this.logger.debug("convert done", result);
            }).catch(e => {
                this.logger.debug("convert failed", e);
            });
    }
    updateMessageContent(chatID, message: AbstractChatMessage) {
        let messageContent = JSON.stringify(message.content);
        let sqlString = "UPDATE messages SET content = '"
            + messageContent + "' where itemID = '"
            + chatID + "'"
            + " and messageID = '"
            + message.messageID + "' ";
        this.databaseObj.executeSql(sqlString, []).then(
            (result) => {
                this.logger.debug("content of message", {message, "updated" : result});
            }).catch(e => {
                this.logger.debug("error content of message 2", {message, "not updated" : e});
            });
        sqlString = "UPDATE messages SET data = '"
            + JSON.stringify(message) + "' where itemID = '"
            + chatID + "'"
            + " and messageID = '"
            + message.messageID + "' ";
        this.databaseObj.executeSql(sqlString, []).then(
            (result) => {
                this.logger.debug("message", {message, "updated" : result});
                }).catch(e => {
                    this.logger.debug("error updating of message", {message, "not updated" : e});
            });
    }
    updateChatTitle(chat: Chat) {
        // let sqlString = "UPDATE items SET title = '"
        //     + chat.title + "' where itemID = '"
        //     + chat.chatID + "'";
        // this.logger.debug(sqlString);
        // this.databaseObj.executeSql(sqlString, []).then(
        //     (result) => {
        //         this.logger.debug("chat title saved in db");
        //     }).catch(e => {
        //         this.logger.debug("error database chat title", e);
        //     });
    }
    showDatabases() {
        // this.sqlite.echoTest();
    }
    removeMessage(message: AbstractChatMessage) {
        this.databaseObj.executeSql("delete from messages where messageID='" + message.messageID + "'", [])
            .then(() => this.logger.debug("deleted"))
            .catch(e => { this.logger.debug(e, "error from database delete item") });
    }
    updateMessageFolding(chat: Chat, message: AbstractChatMessage) {
        let sqlString = "UPDATE messages SET folded = "
            + message.getFoldedInt() + " where itemID = '"
            + chat.chatID + "'"
            + " and messageID = '"
            + message.messageID + "' ";
        this.databaseObj.executeSql(sqlString, []).then(
            (result) => {
                this.logger.debug("sqlstring", sqlString);
                //                    this.logger.debug("folding of message",message,"updated",result);
                //                  this.consoleDialog.log2("messages updated",message);
            }).catch(e => {
                this.logger.debug("error content of message 2", message);
                //              this.consoleDialog.log("error updating message",e);
            });
    }



    truncrate() {
        this.databaseObj.executeSql("delete from items", [])
            .then(() => { this.logger.debug("all deleted") })
            .catch(e => { this.logger.debug("error from truncrate", e) });
        this.databaseObj.executeSql("delete from messages", [])
            .then(() => { this.logger.debug("all deleted") })
            .catch(e => { this.logger.debug("error from truncrate", e) });

        this.databaseObj.executeSql("drop Table items", []).then(() => {
            this.logger.debug("database dropped");
        }).catch(e => {
            this.logger.debug("error on drop database");
        });
        this.databaseObj.executeSql("drop Table messages", []).then(() => {
            this.logger.debug("database dropped");
        }).catch(e => {
            this.logger.debug("error on drop database");
        });
        this.createTables();
    }
    getLeitnerMessages(chat: Chat, numberOfMessages: number): Promise<Array<AbstractChatMessage>> {
        return new Promise((resolve, reject) => {
            let messages: Array<AbstractChatMessage> = [];
            let sqlLiteQuery = "select data,content, received,folded, receivedTime, reviewTime,lastReviewedTime,easinessFactor ,repetittion"
                + " from messages where itemID='" + chat.chatID + "'";
            sqlLiteQuery += " AND reviewTime <= Datetime('" + Tools.Time.getTodayForSqlLite() + "')";
            if (chat.messages.length > 0) {
                let lastMessage: AbstractChatMessage = chat.messages[0];
                // sqlLiteQuery += " AND receivedTime < Datetime('" + lastMessage.getReceivedTimeSqlLiteFormat() + "')";
            }
            sqlLiteQuery += " ORDER BY rowid DESC limit " + numberOfMessages;
            this.logger.debug("sqlLiteQuery lite", sqlLiteQuery);
            this.databaseObj.executeSql(sqlLiteQuery, [])
                .then(data => {
                    if (data.rows.length > 0) {
                        for (var i = data.rows.length - 1; i >= 0; i--) {
                            // //                            this.consoleDialog.log2("folding",data.rows.item(i));
                            // let message = new AbstractChatMessage();
                            // if (!message.content)
                            //     message.content = JSON.parse(data.rows.item(i).content);
                            // message.setReceivedFromInt(data.rows.item(i).received);
                            // message.setFoldingFromInt(data.rows.item(i).folded);
                            // message.setEasinessFactor(data.rows.item(i).easinessFactor);
                            // message.setRepetitions(data.rows.item(i).repetittion);
                            // message.setLastReviewedTime(data.rows.item(i).lastReviewedTime);
                            // message.type = Chat.typeLeitner;
                            // messages.push(message);
                        }
                    }
                    this.logger.debug("look at leitner messages ", messages);
                    resolve(messages);
                }).catch(e => {
                    this.logger.debug("error from get leitner messages", e);
                });
        });
    }
    async getMessageContent(message: AbstractChatMessage): Promise<boolean> {
        return false;
        let sqlLiteQuery = `select content from messages where data like '%"text":"` + message.content + `"%' limit 1`;
        const data = await this.databaseObj.executeSql(sqlLiteQuery, [])
        if (data && data.rows && data.rows.length > 0) {
            for (let i = data.rows.length - 1; i >= 0; i--) {
                let foundContent = data.rows.item(i).content;
                if (foundContent != undefined && foundContent.length > 0 && foundContent != null && foundContent != "null") {
                    message.content = JSON.parse(data.rows.item(i).content);
                    return true;
                }
                else {
                    return false;
                }
            }
        }
        else {
            return false;
        }


    }
    getMessages(chat: Chat, numberOfMessages: number): Promise<Array<AbstractChatMessage>> {
        if (chat.showNewWords()) {
            return this.getLeitnerMessages(chat, numberOfMessages);
        }
        else
            return this.getNormalMessages(chat, numberOfMessages);
    }
    /**
     * function is used to get chats messages, quiz messages, and dictionary messages
     *
     * @param {Chat} chat
     * @param {number} numberOfMessages
     * @returns {Promise<Array<AbstractChatMessage>>}
     * @memberof DatabaseManagerProvider
     */
    getNormalMessages(chat: Chat, numberOfMessages: number): Promise<Array<AbstractChatMessage>> {
        return new Promise((resolve, reject) => {
            this.logger.debug('getNormalMessages');
            let messages = [];
            let sqlLiteQuery = "select data,content, received,folded, receivedTime,reviewTime,lastReviewedTime,easinessFactor ,repetittion from messages where itemID='" + chat.chatID + "'";
            if (chat.messages.length > 0) {
                let lastMessage: AbstractChatMessage = chat.messages[0];
                // sqlLiteQuery += " AND receivedTime < Datetime('" + lastMessage.getReceivedTimeSqlLiteFormat() + "')";
            }
            sqlLiteQuery += " ORDER BY rowid DESC limit " + numberOfMessages;
            this.databaseObj.executeSql(sqlLiteQuery, [])
                .then(data => {
                    if (data.rows.length > 0) {
                        for (var i = data.rows.length - 1; i >= 0; i--) {
                            let messageItem: MessageItemData = <MessageItemData>data.rows.item(i);
                            // let message: AbstractChatMessage = this.createMessageWithMessageObject(JSON.parse(messageItem.data));
                            // if (!message.hasContent())
                            //     message.content = JSON.parse(messageItem.content);
                            // message.setReceivedTime(messageItem.receivedTime)
                            // message.setReceivedFromInt(messageItem.received);
                            // message.setReviewTime(messageItem.reviewTime);
                            // message.setFoldingFromInt(messageItem.folded);
                            // message.setEasinessFactor(messageItem.easinessFactor);
                            // message.setRepetitions(messageItem.repetittion);
                            // message.setLastReviewedTime(messageItem.lastReviewedTime);
                            // messages.push(message);
                        }
                    }
                    resolve(messages);
                }).catch(e => {
                    this.logger.debug("error from get messages", e);
                });
        });
    }
    selectMessagesFromChat(chat: Chat, needle: string): Promise<Array<AbstractChatMessage>> {
        return new Promise((resolve, reject) => {
            let messages: Array<AbstractChatMessage> = [];
            let sqlLiteQuery = "select data,content, received,folded, receivedTime,reviewTime,lastReviewedTime,easinessFactor ,repetittion from messages where itemID='"
                + chat.chatID + "' AND content like '%" + needle + "%' limit 6";
            this.databaseObj.executeSql(sqlLiteQuery, [])
                .then(data => {
                    if (data.rows.length > 0) {
                        for (var i = data.rows.length - 1; i >= 0; i--) {
                            //                            let message = Tools.Creator.createMessageWithMessageObject(JSON.parse(data.rows.item(i).data));
                            // let message: AbstractChatMessage = this.createMessageWithMessageObject(JSON.parse(data.rows.item(i).data));
                            // //                            let message  = new Message(JSON.parse(data.rows.item(i).data));
                            // if (!message.hasContent())
                            //     message.content = JSON.parse(data.rows.item(i).content);
                            // message.setReceivedTime(data.rows.item(i).receivedTime);
                            // message.setReceivedFromInt(data.rows.item(i).received);
                            // message.setReviewTime(data.rows.item(i).reviewTime);
                            // message.setFoldingFromInt(data.rows.item(i).folded);
                            // message.setEasinessFactor(data.rows.item(i).easinessFactor);
                            // message.setRepetitions(data.rows.item(i).repetittion);
                            // message.setLastReviewedTime(data.rows.item(i).lastReviewedTime);
                            // messages.push(message);
                        }
                    }
                    resolve(messages);
                }).catch(e => {
                    this.logger.debug("error from get messages", e);
                });
        });
    }
}